import { defineComponent, reactive, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import PropTypes from '../_utils/props-types';
import { getPrefixCls } from '../_utils/props-tools';
import { $g } from '../../utils/global';
import { mutations } from '../../store/types';
import { Menu } from 'ant-design-vue';
import MiMenuItem from './item';
import MiSubMenu from './submenu';
export const menuProps = () => ({
    prefixCls: String,
    items: PropTypes.array,
    indent: PropTypes.number.def(16)
});
export default defineComponent({
    name: 'MiMenu',
    inheritAttrs: true,
    props: menuProps(),
    setup(props) {
        const store = useStore();
        const route = useRoute();
        const menus = reactive({});
        let data = reactive((props.items ?? []));
        const prefixCls = getPrefixCls('menu', props.prefixCls);
        const collapsed = computed(() => store.getters['layout/collapsed']);
        let path = route.path;
        let find = false;
        let relation = [];
        let menuChildrenItems = {};
        const getChildrenRelationshipChain = (items, pkey, save = false) => {
            items.forEach((item) => {
                const name = $g.prefix + item.name;
                if (!find) {
                    relation.push(name);
                    if (path === item.path)
                        find = true;
                }
                if (save) {
                    menuChildrenItems[name] = {
                        status: true,
                        pkey
                    };
                }
                const children = item.children;
                if (children?.length > 0)
                    getChildrenRelationshipChain(children, name, save);
                if (!find)
                    relation.pop();
            });
        };
        const getRelationshipChain = (parse = true) => {
            path = route.path;
            find = false;
            relation = [];
            data.forEach((items) => {
                const name = $g.prefix + items.name;
                if (!find) {
                    relation.push(name);
                    if (path === items.path)
                        find = true;
                }
                if (parse)
                    menus[name] = {};
                const children = items.children;
                if (children?.length > 0) {
                    getChildrenRelationshipChain(children, name, parse);
                    if (parse) {
                        menus[name] = menuChildrenItems;
                        menuChildrenItems = {};
                    }
                }
                if (!find)
                    relation = [];
            });
            setRelationshipChain(relation);
        };
        const setRelationshipChain = (relation = []) => {
            if (relation.length > 0) {
                $g.menus.relationshipChain = [...relation];
                const active = [relation[relation.length - 1]];
                $g.menus.active = active;
                store.commit(`layout/${mutations.layout.active}`, active);
                if (!collapsed.value && $g.menus.accordion) {
                    relation.pop();
                    const opens = [...relation];
                    $g.menus.opens = opens;
                    store.commit(`layout/${mutations.layout.opens}`, opens);
                }
                relation = [];
            }
        };
        getRelationshipChain();
        watch(route, () => {
            const active = `${$g.prefix}${route.name}`;
            setActive({ key: active });
            getRelationshipChain(false);
        });
        watch(props.items, () => {
            data = props.items;
        });
        const getMenuItems = () => {
            const items = [];
            data?.forEach((item) => {
                if (item?.children?.length > 0) {
                    items.push(<MiSubMenu item={item} topLevel={collapsed.value} key={$g.prefix + item.name}/>);
                }
                else {
                    items.push(<MiMenuItem item={item} topLevel={collapsed.value} key={$g.prefix + item.name}/>);
                }
            });
            return [...items];
        };
        const setActive = (item) => {
            $g.menus.active = [item.key];
            store.commit(`layout/${mutations.layout.active}`, [item.key]);
        };
        const setOpenKeys = (openKeys) => {
            let opens = [];
            if (openKeys.length > 0) {
                opens = openKeys;
                if ($g.menus.accordion) {
                    const first = openKeys[0];
                    const last = openKeys[openKeys.length - 1];
                    if (menus[first] && !menus[first][last])
                        opens = [last];
                }
            }
            $g.menus.opens = opens;
            store.commit(`layout/${mutations.layout.opens}`, opens);
        };
        return () => (<Menu class={prefixCls} ref={prefixCls} theme="dark" inlineIndent={props.indent} mode={'inline'} onOpenChange={setOpenKeys} openKeys={$g.menus.opens} selectedKeys={$g.menus.active}>
                {getMenuItems()}
            </Menu>);
    }
});
